import { ApiConfig } from './types'

export const ping: ApiConfig<void, 'pong'> = {
  buildRequest: () => ({ method: 'GET', url: '/ping' }),
  apiVersionPath: '',
}
